import { varaaKapasiteettia, type Kohde } from "./api";
import { t } from "./kieli";

/* ── Kenttätilin työmaat ─────────────────────────────────────
   Päätös 13.9.2026: kenttätili näkee vain ne työmaat joille se on
   sidottu, ja niistäkin vain aktiiviset. Tyhjä valinta ei tarkoita
   «kaikki» vaan «ei mitään», joten luonti ei etene ilman valintaa.

   Valmis ja peruuntunut näytetään vain jos ne on jo valittu: uutta
   tiliä ei sidota päättyneeseen, mutta olemassa olevan sidonnan on
   näyttävä, muuten sen poistaminen olisi näkymätöntä. Muu kuin
   aktiivinen saa sanan «ei näy kentällä» — sidonta ja näkyvyys ovat
   eri asia, ja vain jälkimmäinen on se mitä kenttätekijä kokee. */
export function TyomaaValinta({ kohteet, valitut, muuta }: {
  kohteet: Kohde[];
  valitut: number[];
  muuta: (idt: number[]) => void;
}) {
  const nakyvat = kohteet.filter((k) =>
    (k.tila !== "valmis" && k.tila !== "peruuntunut") || valitut.includes(k.id));
  if (nakyvat.length === 0) {
    return <span className="dim">{t("muu.tyomaa.ei_tyomaita")}</span>;
  }
  return (
    <fieldset data-tyomaavalinta=""
              style={{ border: 0, padding: 0, margin: 0, display: "flex", flexWrap: "wrap", gap: "4px 14px" }}>
      <legend className="hint" style={{ padding: 0, marginBottom: 4 }}>
        {t("muu.tyomaa.selite")}
      </legend>
      {nakyvat.map((k) => (
        <label key={k.id} style={{ display: "inline-flex", gap: 6, alignItems: "center" }}>
          <input type="checkbox" value={k.id} checked={valitut.includes(k.id)}
                 onChange={(e) => muuta(e.target.checked
                   ? [...valitut, k.id]
                   : valitut.filter((x) => x !== k.id))} />
          <span className="mono">{k.tunnus}</span>
          <span>{k.nimi}</span>
          {/* Sama ehto kuin kannan f_kohde_varaa: vain aktiivinen näkyy — uusi tila piilottaa oletuksena (13.9.2026). */}
          {!varaaKapasiteettia(k.tila) && <span className="dim">· {k.tila}, {t("muu.tyomaa.ei_nay")}</span>}
        </label>
      ))}
    </fieldset>
  );
}
